import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import TeamSidebar from '../components/TeamSidebar';
import { Outlet } from 'react-router';
import Header from '@/components/Header';
import TeamHeader from '../components/TeamHeader';
import { Toaster } from '@/components/ui/sonner';

export default function TeamLayout() {
  return (
    <>
      <Header />
      <SidebarProvider
        className="relative h-full pt-(--header-height)"
        defaultOpen={true}
      >
        <TeamSidebar />
        <SidebarInset className="flex flex-col h-[calc(100vh-var(--header-height))] overflow-hidden">
          <TeamHeader />
          <main className="flex-1 overflow-auto p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
      <Toaster />
    </>
  );
}
